import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { FontTag, fontTagToCssClass } from "../../../../../agreed/fonts";
import { ReactComponent as IconCheck } from "../../../../../icons/check-filled.svg";
import "./style.scss";

interface Props {
  optionItems: Array<{
    assetUrl?: string;
    key?: string;
    label?: string;
    onSelect: () => void;
    price?: string;
    value: string;
  }>;
  selectedValue?: string;
  type?: "asset" | "color" | "text";
}

const OptionsListItem: FunctionComponent<Props> = ({ optionItems, selectedValue, type }) => {
  let renderedItems;

  if (type === "color") {
    renderedItems = optionItems.map((option) => {
      return (
        <div
          className={classNames("OptionsListItem-item", {
            "OptionsListItem-item--selected": selectedValue === option.key,
          })}
          key={option.key || option.value}
          onClick={() => option.onSelect()}
        >
          <div
            className={classNames("OptionsListItem-item-chip", {
              "OptionsListItem-item-chip--bordered": option.value === "#ffffff",
            })}
            style={{ backgroundColor: option.value }}
          >
            {selectedValue === option.key && (
              <div className="OptionsListItem-item-selection">
                <IconCheck />
              </div>
            )}
          </div>
        </div>
      );
    });
  } else if (type === "text") {
    renderedItems = optionItems.map((option) => {
      return (
        <div
          className={classNames(
            "OptionsListItem-item",
            fontTagToCssClass(option.value as FontTag),
            {
              "OptionsListItem-item--selected": selectedValue === option.key,
            }
          )}
          key={option.key || option.value}
          onClick={() => option.onSelect()}
        >
          {option.label}
        </div>
      );
    });
  } else {
    renderedItems = optionItems.map((option) => {
      const isSelected = selectedValue === option.value;

      return (
        <div
          className={classNames("OptionsListItem-item", {
            "OptionsListItem-item--selected": isSelected,
          })}
          key={option.value}
          onClick={() => option.onSelect()}
        >
          <div
            className={classNames("OptionsListItem-item-asset", {
              "OptionsListItem-item-asset-noImg": !option.assetUrl,
            })}
          >
            {!!option.assetUrl && <img src={option.assetUrl} alt={option.label} />}
            {isSelected && (
              <div className="OptionsListItem-item-selection">
                <IconCheck />
              </div>
            )}
          </div>
          <span className="OptionsListItem-item-label">
            <span className="OptionsListItem-item-label-text">{option.label}</span>
            <span className="OptionsListItem-item-label-price">{option.price}</span>
          </span>
        </div>
      );
    });
  }

  return (
    <div
      className={classNames("OptionsListItem", {
        "OptionsListItem--color": type === "color",
        "OptionsListItem--text": type === "text",
      })}
    >
      {renderedItems}
    </div>
  );
};

export default OptionsListItem;
